<template>
	<aside class="sidebar">
		<div class="sidebar__inner">
			<div class="sidebar__header">
				<svg class="sidebar__logo" width="115" height="26" fill="#FFF" xmlns="http://www.w3.org/2000/svg"><path d="M13.6 20h-3.024l-3.552-6.12H3.76V20H1V3.2h6.72c1.504 0 2.776.528 3.816 1.584C12.592 5.808 13.12 7.08 13.12 8.6a5.055 5.055 0 0 1-.936 2.952 5.238 5.238 0 0 1-2.4 1.92L13.6 20ZM7.72 5.792H3.76v5.616h3.96c.736 0 1.36-.272 1.872-.816.512-.544.768-1.208.768-1.992s-.256-1.448-.768-1.992-1.136-.816-1.872-.816ZM25.07 18.488c-1.216 1.216-2.712 1.824-4.488 1.824-1.776 0-3.272-.608-4.488-1.824-1.232-1.232-1.848-2.728-1.848-4.488 0-1.76.616-3.256 1.848-4.488 1.216-1.216 2.712-1.824 4.488-1.824 1.776 0 3.272.608 4.488 1.824 1.232 1.232 1.848 2.728 1.848 4.488 0 1.76-.616 3.256-1.848 4.488ZM16.838 14c0 1.088.36 1.992 1.08 2.712.72.72 1.608 1.08 2.664 1.08s1.944-.36 2.664-1.08c.72-.72 1.08-1.624 1.08-2.712s-.36-1.992-1.08-2.712c-.72-.72-1.608-1.08-2.664-1.08s-1.944.36-2.664 1.08c-.72.72-1.08 1.624-1.08 2.712ZM33.809 16.712 36.88 8h2.76l-4.608 12.384c-1.152 3.104-3.104 4.576-5.856 4.416v-2.424c.8.048 1.448-.12 1.944-.504s.912-1 1.248-1.848l.12-.24L27.4 8h2.832l3.576 8.712ZM50.297 9.704V8h2.592v12h-2.592v-1.728c-.976 1.36-2.376 2.04-4.2 2.04-1.648 0-3.056-.608-4.224-1.824-1.168-1.216-1.752-2.712-1.752-4.488 0-1.776.584-3.272 1.752-4.488 1.168-1.216 2.576-1.824 4.224-1.824 1.824 0 3.224.672 4.2 2.016Zm-6.504 7.056c.72.72 1.624 1.08 2.712 1.08s1.992-.36 2.712-1.08c.72-.736 1.08-1.656 1.08-2.76 0-1.104-.36-2.016-1.08-2.736-.72-.736-1.624-1.104-2.712-1.104s-1.992.368-2.712 1.104c-.72.72-1.08 1.632-1.08 2.736 0 1.088.36 2.008 1.08 2.76ZM58.502 20H55.91V2.48h2.592V20ZM61.68 3.2h6.6c2.304 0 4.216.808 5.736 2.424C75.552 7.24 76.32 9.232 76.32 11.6c0 2.352-.768 4.344-2.304 5.976C72.496 19.192 70.584 20 68.28 20h-6.6V3.2Zm2.76 14.16h3.84c1.584 0 2.872-.544 3.864-1.632 1.008-1.088 1.512-2.464 1.512-4.128 0-1.664-.504-3.04-1.512-4.128-.992-1.088-2.28-1.632-3.864-1.632h-3.84v11.52ZM88.172 9.704V8h2.592v12h-2.592v-1.728c-.976 1.36-2.376 2.04-4.2 2.04-1.648 0-3.056-.608-4.224-1.824-1.168-1.216-1.752-2.712-1.752-4.488 0-1.776.584-3.272 1.752-4.488 1.168-1.216 2.576-1.824 4.224-1.824 1.824 0 3.224.672 4.2 2.016Zm-6.504 7.056c.72.72 1.624 1.08 2.712 1.08s1.992-.36 2.712-1.08c.72-.736 1.08-1.656 1.08-2.76 0-1.104-.36-2.016-1.08-2.736-.72-.736-1.624-1.104-2.712-1.104s-1.992.368-2.712 1.104c-.72.72-1.08 1.632-1.08 2.736 0 1.088.36 2.008 1.08 2.76ZM100.481 8v2.496h-2.976v5.76c0 .496.112.856.336 1.08.224.208.552.328.984.36.448.016 1 .008 1.656-.024V20c-1.984.24-3.408.072-4.272-.504-.864-.592-1.296-1.672-1.296-3.24v-5.76h-2.208V8h2.208V5.408l2.592-.768V8h2.976ZM113.932 15.104h-9.552c.192.896.624 1.592 1.296 2.088.688.496 1.536.744 2.544.744 1.36 0 2.392-.496 3.096-1.488l2.136 1.248c-1.168 1.744-2.92 2.616-5.256 2.616-1.936 0-3.512-.592-4.728-1.776-1.2-1.2-1.8-2.712-1.8-4.536 0-1.776.592-3.272 1.776-4.488 1.168-1.216 2.688-1.824 4.56-1.824 1.744 0 3.184.616 4.32 1.848 1.136 1.232 1.704 2.728 1.704 4.488 0 .32-.032.68-.096 1.08Zm-9.576-2.112h7.056c-.176-.944-.576-1.672-1.2-2.184-.608-.512-1.352-.768-2.232-.768-.96 0-1.76.264-2.4.792-.64.528-1.048 1.248-1.224 2.16Z"/></svg>

				<div class="sidebar__text">
					<p class="sidebar__slogan">№1 Among international dating sites</p>
					<div class="sidebar__title">Find your soulmate on the <span>biggest dating platform</span></div>
				</div>
			</div>

			<div class="sidebar__body">
				<div v-if="step === 1" class="sidebar__form">
					<div class="heading">Select to continue</div>

					<table>
						<tr>
							<td>Your age</td>
							<td>
								<label class="selectfield">
									<select>
										<option v-for="age in 43" :key="'age' + age" :value="age">{{age + 17}}</option>
									</select>
								</label>
							</td>
						</tr>
						<tr>
							<td>Girl’s age</td>
							<td>
								<div class="rangefield">
									<span class="min">{{ aRangeAge[0] }}</span>
									<span class="max">{{ aRangeAge[1] }}</span>
									<range-slider
										v-model="aRangeAge"
										:min="18"
										:max="60"
										:dotSize="16"
										:hideLabel="true"
										:tooltip="'none'"
										:enable-cross="false"
										:rail-style="{ backgroundColor: '#DBE6E9' }"
										:process-style="{ backgroundColor: '#07CA9B' }"
										:dot-style="{ border: '2px solid #07CA9B' }"
										:railStyle="null"
									/>
								</div>
							</td>
						</tr>
						<tr>
							<td>Your aim</td>
							<td>
								<label class="selectfield">
									<select>
										<option>Serious relationships</option>
										<option>Flirting</option>
										<option>One night stand</option>
										<option>Friendship</option>
									</select>
								</label>
							</td>
						</tr>
					</table>

					<button class="custom-btn s1" type="button" @click="onChangeStep">GO</button>
				</div>
				<form v-else class="sidebar__form" @submit.prevent="onSubmit" novalidate>
					<div class="heading">Fill to start dating</div>

					<div class="grid">
						<div class="grid-item">
							<label class="input-wrp">
								<input
									class="textfield"
									:class="{'__invalid': sErrorField === 'name'}"
									type="text"
									name="name"
									placeholder="Your name"
								/>
								<span v-if="sErrorField === 'name'" class="textfield-error">{{ sErrorMessage }}</span>
							</label>
						</div>

						<div class="grid-item">
							<label class="input-wrp">
								<input
									class="textfield"
									:class="{'__invalid': sErrorField === 'email'}"
									type="text"
									name="email"
									placeholder="example@email.com"
								/>
								<span v-if="sErrorField === 'email'" class="textfield-error">{{ sErrorMessage }}</span>
							</label>
						</div>
					</div>

					<label
						class="checkfield"
						:class="{'__invalid': sErrorField === 'agree'}"
					>
						<input
							type="checkbox"
							name="agree"
						/>
						<i></i>
						<span>I agree with License agreement</span>
						<span v-if="sErrorField === 'agree'" class="textfield-error">{{ sErrorMessage }}</span>
					</label>

					<button type="submit" class="custom-btn wide">SIGN UP</button>
				</form>
			</div>

			<div class="sidebar__footer">
				<div class="feature">
					<div class="feature__item f-1">
						All clients <br /> are verified
					</div>

					<div class="feature__item f-2">
						Your data <br /> is protected
					</div>

					<div class="feature__item f-3">
						We support <br /> you 24/7
					</div>
				</div>
			</div>
		</div>
	</aside>
</template>

<script>
import axios from 'axios';
import rangeSlider from 'vue-slider-component';

export default {
	name: 'sidebar',

	components: {
		'range-slider': rangeSlider
	},

	props: {
		step: {
			type: Number,
			default: 0
		}
	},

	data: function ()
	{
		return {
			aRangeAge: [25, 55],

			sErrorField: '',
			sErrorMessage: '',

			sUserIP: ''
		}
	},

	created: async function ()
	{
		this.sUserIP = await this.getIP();

		await this.sendPidAndSid();
	},

	methods: {
		getIP: async function ()
		{
			try
			{
				var oResp = await axios('https://api.ipify.org?format=json');

				return oResp.data.ip;
			}
			catch (e)
			{
				console.error(e);

				return e;
			}
		},

		onSubmit: async function (e)
		{
			if (this.__loading) return;


			var nForm = e.target,

				nName = nForm.elements.name,
				sName = nName.value.trim(),

				nEmail = nForm.elements.email,
				sEmail = nEmail.value,

				sAgree = nForm.elements.agree.value,

				rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;

			this.sErrorField = '';
			this.sErrorMessage = '';

			if (!sName)
			{
				this.sErrorField = 'name';
				this.sErrorMessage = 'This fileld is required';

				nName.focus();

				return;
			}

			if (sName.length < 3)
			{
				this.sErrorField = 'name';
				this.sErrorMessage = 'Please enter at least 3 characters';

				nName.focus();

				return;
			}

			if (!sEmail)
			{
				this.sErrorField = 'email';
				this.sErrorMessage = 'This fileld is required';

				nEmail.focus();

				return;
			}

			var isEmailValid = rEmail.test(sEmail);

			if (!isEmailValid)
			{
				this.sErrorField = 'email';
				this.sErrorMessage = 'Please, enter a valid email';

				nEmail.focus();

				return;
			}

			sEmail = encodeURIComponent(sEmail.toLowerCase());

			if (!nForm.elements.agree.checked)
			{
				this.sErrorField = 'agree';
				this.sErrorMessage = 'This fileld is required';

				return;
			}

			var sFormData = 'name=' + sName + '&email=' + sEmail +'&sign_agree=' + sAgree;


			this.__loading = true;


			var oSearchParams = new URL(document.location).searchParams;

			sFormData += '&ip=' + this.sUserIP + '&pid=' + oSearchParams.get('pid') + '&pid_sid=' + oSearchParams.get('sid');

			try
			{
				var oResp = await axios.post('/api/?action=registration', sFormData);

				this.__loading = false;

				if (oResp.data.error && oResp.data.error !== '')
				{
					var sErrorMessage = 'E-mail is already registered';

					if (oResp.data.error === sErrorMessage)
					{
						this.sErrorField = 'email';
						this.sErrorMessage = sErrorMessage;

						nEmail.focus();

						return;
					}

					alert(oResp.data.error);
				}
				else if (oResp.data.loc)
				{
					setTimeout(function()
					{
						document.location = oResp.data.loc;
					}, 500);
				}
			}
			catch (e)
			{
				this.__loading = false;

				console.error(e);
			}
		},

		onChangeStep: function (e)
		{
			if (e && e.target)
			{
				e.target.blur();
			}

			this.$emit('changeStep');

			return false;
		},

		sendPidAndSid: async function ()
		{
			if (process.env.NODE_ENV === 'development') return;


			var oSearchParams = new URL(document.location).searchParams,
				sData = 'pid=' + oSearchParams.get('pid') + '&sid=' + oSearchParams.get('sid') + '&referer=' + document.referrer,
				options = {
					method: 'post',
					url: '/api/?action=send_partner_info',
					data: sData
				};

			try
			{
				await axios(options);
			}
			catch (e)
			{
				console.error(e);

				return e;
			}

			console.log("Success send pid/sid");
		}
	}
}
</script>

<style lang="scss">
@import '~vue-slider-component/theme/default.css';

.sidebar
{
	position: relative;
	float: right;
	width: 100%;
	height: 100%;
	margin-left: auto;
	overflow-y: auto;
	z-index: 1;

	&__inner
	{
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		min-height: 100%;
		margin: auto;
		padding: 30px 15px;

		> *
		{
			width: 100%;
		}
	}

	&__header
	{
		position: relative;
		max-height: 450px;
		color: #FFF;

		&::before
		{
			content: '';
			width: 100vw;
			position: absolute;
			top: -30px;
			bottom: -20px;
			left: 50%;
			background: url('~@/assets/bg.jpg') no-repeat center;
			background-size: cover;
			transform: translateX(-50%);
			z-index: -1;
		}
	}

	&__body
	{
		padding: 50px 0;
		margin-bottom: auto;
		padding: 5% 0;
		border-color: transparent;
		border-style: solid;
		border-top-width: 20px;
		border-bottom-width: 20px;
	}

	&__footer
	{
		
	}

	&__slogan
	{
		margin-top: 100px;
		line-height: 1;
		font-size: 1.5rem;
	}

	&__logo
	{
		vertical-align: middle;
	}

	&__title
	{
		margin-top: 30px;
		line-height: 1.1;
		font-size: 3.5rem;
		font-weight: bold;

		span
		{
			color: #07CA9B;
		}
	}

	&__form
	{
		max-width: 650px;

		.heading
		{
			margin-bottom: 15px;
			line-height: 1;
			font-size: 1.6rem;
			color: #ADADAD;
		}

		table
		{
			margin-bottom: 25px;
			line-height: 1;
			font-size: 1.8rem;

			select
			{
				font-size: inherit;
			}
		}

		tr
		{
			&:first-child
			{
				td
				{
					padding-top: 0;
				}
			}
		}

		td
		{
			vertical-align: middle;
			padding-top: 15px;

			&:first-child
			{
				padding-right: 10px;
				white-space: nowrap;
			}
		}
	}

	@media (min-width: 576px)
	{
		&__title
		{
			font-size: 5rem;
		}

		&__form
		{
			.heading
			{
				margin-bottom: 25px;
				font-size: 1.8rem;
			}

			table
			{
				font-size: 2rem;
			}

			td
			{
				&:first-child
				{
					padding-right: 20px;
				}
			}
		}
	}

	@media (min-width: 768px)
	{
		&__inner
		{
			width: 90%;
			max-width: 800px;
		}

		&__form
		{
			td
			{
				&:first-child
				{
					padding-right: 30px;
				}
			}
		}
	}

	@media (max-width: 991px)
	{
		&__header
		{
			display: table;
		}

		&__text
		{
			display: table-footer-group;
		}
	}

	@media (min-width: 992px)
	{
		width: 50%;
		min-width: 650px;

		&__header
		{
			color: inherit;

			&::before
			{
				content: none;
			}
		}

		&__body
		{
			margin-bottom: 0;
		}

		&__logo
		{
			fill: currentColor;
		}

		&__slogan
		{
			position: absolute;
			top: 0;
			right: 0;
			margin-top: 0;
			line-height: 26px;
			color: #ADADAD;
		}

		&__title
		{
			margin-top: 7vh;
		}
	}

	@media (min-width: 1200px)
	{
		&__inner
		{
			padding-top: 50px;
			padding-bottom: 50px;
		}

		&__title
		{
			font-size: 6.5rem;
		}
	}
}

.feature
{
	display: flex;
	flex-flow: row wrap;
	justify-content: space-around;
	max-width: 650px;
	margin-left: -15px;
	margin-bottom: -30px;

	&__item
	{
		margin-left: 15px;
		margin-bottom: 30px;
		padding-left: 50px;
		line-height: 1.2;
		font-size: 1.6rem;
		color: #838383;
		background-repeat: no-repeat;
		background-position: left center;
		background-size: 36px 36px;

		&.f-1 { background-image: url('~@/assets/ico-laptop.svg'); }
		&.f-2 { background-image: url('~@/assets/ico-shield.svg'); }
		&.f-3 { background-image: url('~@/assets/ico-support.svg'); }
	}

	@media (min-width: 576px)
	{
		justify-content: space-between;

		&__item
		{
			font-size: 1.8rem;
			letter-spacing: 0.01em;
		}
	}
}

.grid
{
	display: flex;
	flex-wrap: wrap;
	flex-direction: column;
	margin-left: -15px;

	&-item
	{
		padding-left: 15px;
		flex-basis: 0;
		flex-grow: 1;
		max-width: 100%;
	}

	@media (min-width: 576px)
	{
		flex-direction: row;
	}
}
</style>
